import axios from "@/axios"

const url = "/api/brain/warehouse/products/categories"

class CategoriesService {
	async getCategories(params) {
		try {
			const data = await axios.get(`${url}/index`, { params })
			return data.data
		} catch (error) {
			throw error
		}
	}

	async createCategories(datas) {
		try {
			const data = await axios.post(`${url}/save`, datas)
 			return data.data
		} catch (error) {
			throw error
		}
	}

	async deleteCategories(id) {
		try {
			const data = await axios.delete(`${url}/destroy/${id}`)
			return data.data
		} catch (error) {
			throw error
		}
	}
	async updateCategories(id, datas) {
		try {
			const data = await axios.put(`${url}/edit/${id}`, datas)
			return data.data
		} catch (error) {
			throw error
		}
	}

	async getCategoriesForSelect(){
		try {
			const data = await axios.get(`${url}/get-categories`);
			return data
		} catch (error) {
			throw error
		}
	}
}

export default new CategoriesService()
